<template>
    <modal v-model="isVisible">
      <div class="c-modalCard">
        <header class="c-modalCard__header">
          <h4 class="c-modalCard__title">Confirmar da ação de reprocessar imagens de produtos</h4>
          <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
            <i class="i-remove"></i>
          </a>
        </header>
  
        <div class="c-modalCard__body">
          Reprocessar imagens pode sobrecarregar a capacidade da sua fila de processamento e
          com isso gerar atraso na comunicação com o marketplace.
        </div>
  
        <div class="c-modalCard__body">
          Tem certeza de que deseja Reprocessar as imagens do produto {{ productInText }}?
        </div>
  
        <footer class="c-modalCard__footer">
          <button type="button" class="btn"  v-on:click="cancel()">Não</button>
          <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
        </footer>
      </div>
    </modal>
  </template>
    
  <script>
    export default {
      data: () => ({
        modal: null,
        isVisible: false
      }),
      props: {
        value: {
          type: Boolean,
          required: true
        },
        product: {
          type: Object,
          required: false
        },
        typeAction: {
          type: String,
          required: false
        }
      },
      created () {
        this.isVisible = this.value
      },
      mounted () {
        this.modal = document.querySelector('div.c-modal')
        this.modal.onclick = (event) => {
          if (event.target === this.modal) {
            this.close()
          }
        }
        document.body.onkeyup = (event) => {
          if (event.code === 'Escape') {
            this.close()
          }
        }
      },
      methods: {
        confirm () {
          this.$emit('confirm', true)
          this.close()
        },
        cancel () {
          this.close()
        },
        close () {
          delete document.body.onkeyup
          delete this.modal.onclick

          this.isVisible = false
        }
      },
      computed: {
        productInText () {
          if (this.product === null) {
            return null
          }

          return `'${this.product.title}'`
        }
      },
      watch: {
        isVisible (value) {
          this.$emit('input', value)
        },
        value (value) {
          this.isVisible = value
        }
      }
    }
  </script>



// WEBPACK FOOTER //
// ModalReprocessImages.vue?648956bd